<template>
  <div class="container">
    <el-table :data="taskListFilter" style="width: 100%">
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        prop="编号"
        label="#"
      >
      </el-table-column>
      <el-table-column header-align="center" align="center" label="类型">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type === 'mark'">预标注</el-tag>
          <el-tag type="danger" v-else>检测</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="模型"
        prop='model_name'
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="餐厅"
      >
        <template slot-scope="scope">
            {{findCanteen(scope.row)}}
          </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="批次时间"
      >
        <template slot-scope="scope">
          {{ scope.row.label_create_ts | tsToDate }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.status === '1'">未完成</el-tag>
          <el-tag type="success" v-else>已完成</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        prop="label_create_ts"
        label="任务时间"
      >
        <template slot-scope="scope">
          {{ scope.row.task_create_ts | tsToDate }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="viewDetail(scope.row)"
            >查看</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetAllTaskList, apiGetPreMarkTaskDetails, apiGetRegionCheckData} from '@/api';
import moment from 'moment';

export default {
  name: "regionTask",
  components: {},
  data() {
    return {
      taskList: []
    };
  },
  mounted() {
    this.getAllTaskList();
  },
  filters: {
    tsToDate(ts) {
      return moment(ts * 1000).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions([
      'setCheckRegionData',
      'setPremarkData'
    ]),
    async viewDetail(row) {
      const {task_id, type} = row;
      if (type === 'mark') {
        try {
          const res = await apiGetPreMarkTaskDetails(row.task_id);
          this.setPremarkData({data: res, label_task_id: row.label_task_id});
          // this.$message.warning('详情获取成功, 正在跳转');
          this.$emit('setActiveTab', 'regionFix');
        } catch (e) {
          // console.log(new Error(e).message);
          console.log(e);
          if (e.message === '-2') {
            this.$message.error('任务正在进行中, 请等待...');
          } else {
            this.$message.error('查询详细信息失败' + e.message);
          }
        }
      } else {
        try {
          const res = await apiGetRegionCheckData(row.task_id);
          this.setCheckRegionData({data: res, label_task_id: row.label_task_id});
          this.$emit('setActiveTab', 'regionCheckResult');
        } catch (e) {
          // console.log(new Error(e).message);
          if (e.message === '-2') {
            this.$message.error('任务正在进行中, 请等待...');
          } else {
            this.$message.error('查询详细信息失败' + e.message);
          }
        }
      }
    },
    async getAllTaskList() {
      try {
        const res = await apiGetAllTaskList();
        this.taskList = res;
      } catch (e) {
        this.$message.error("获取全部图片错误" + e.message);
      }
      // this.taskList = [
      //   {
      //     id: 9,
      //     task_id: "0082e82a51f611e9b0f200163e09e229",
      //     parent_task_id: null,
      //     status: "2",
      //     pre_mark: 1,
      //     model_name: "lu2",
      //     canteen_id: "1",
      //     label_create_ts: 1553603669,
      //     task_create_ts: null
      //   }
      // ];
    },
    findCanteen (row) {
      const canteen_id = Number(row.canteen_id);
      let res = this.$_.find(this.allCanteenList, a => a.canteen_id === canteen_id);
      const noCanteen = '无记录';
      if (res) {
        return res.eatery_name + ', ' + res.canteen_name;
      } else {
        return '无记录';
      }
    }
  },
  computed: {
    ...mapGetters([
      'allCanteenList'
    ]),
    taskListFilter  () {
      let list = this.$_.cloneDeep(this.taskList);
      list.sort((a, b) => -a.task_create_ts + b.task_create_ts);
      return list;
    }
  },
  watch: {
  }
};
</script>
<style></style>
